import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { OracleResponsysCopySource } from 'app/model/pipeline/copysource/oracle-responsys.copysource';
import { OracleResponsysLinkedService } from 'app/model/linkedservice/oracle-responsys.linkedservice';
import { useEncryptedEndpointsRadioSwitch } from './linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const oracleResponsysMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(OracleResponsysLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.OracleResponsys_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    category: ['ServicesApps'],
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(OracleResponsysCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'endpoint',
            label: stringResources.ModelName_Endpoint,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'clientId',
            label: stringResources.ModelName_ClientId,
            required: true,
            isLabelVertical: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ]
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'clientSecret',
            label: stringResources.ModelName_ClientSecret,
            child: {
                type: 'password',
                required: true,
                label: stringResources.ModelName_ClientSecret,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.OracleResponsys_DisplayText),
                stringResources.ModelName_ClientSecret)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
